import React from "react";
import { SCREEN_ENTER_CLASS } from "./useModalMotion";

// Wraps a route's content so it enters with the app's screen motion: a short fade and rise
// (reduced motion: a fade). Key it by the route so each navigation plays it once. A page
// that renders its own position:fixed background (PageBackground) passes `fadeOnly`: a
// transform on this wrapper would carry the fixed background with it while it moves.
export function ScreenEnter({ fadeOnly = false, style, children }) {
  return (
    <div className={fadeOnly ? `${SCREEN_ENTER_CLASS} ${SCREEN_ENTER_CLASS}--fade` : SCREEN_ENTER_CLASS} style={style}>
      {children}
    </div>
  );
}
